module.exports = "ez-registration input.city-input {\n  height: 60px;\n  line-height: 50px;\n  font-size: 23px;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  color: #fff;\n}\nez-registration .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/registration/location/location.component.less
// module id = 526
// module chunks = 0